import { date as commonDate } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

// a run's date and version, as the drawer's picker, the list and the details
// page show it: "March 31, 2026, Version 1"
export const getReportingDateVersionLabel = (
  reportingDate: Util.FullDateStr,
  fileVersion: number,
): string =>
  `${commonDate.fullDateStrToHumanDateString(
    reportingDate,
  )}, Version ${fileVersion}`;

export const getReportingDateVersionShortString = (
  reportingDate: Util.FullDateStr,
  fileVersion: number,
) => {
  return `Reporting Date: ${commonDate.fullDateStrToShortMonthDayString(
    reportingDate,
  )}, Version ${fileVersion}`;
};
